<template>
  <div class="approval-flow-metadata d-flex flex-column ga-1">
    <ApprovalFlowSlotField
      label="Flow Template"
      :label-width="110"
    >
      <span class="text-body-2 text-textDarkest font-weight-medium">
        {{ templateName || '—' }}
      </span>
    </ApprovalFlowSlotField>

    <ApprovalFlowSlotField
      label="Stages"
      :label-width="110"
    >
      <span class="text-body-2 text-textDarkest font-weight-medium">
        {{ flow ? `${flow.current_stage} / ${flow.stage_count}` : '—' }}
      </span>
    </ApprovalFlowSlotField>

    <ApprovalFlowSlotField
      label="Created on"
      :label-width="110"
    >
      <span class="text-body-2 text-textDarkest font-weight-medium">
        {{ formatApprovalFlowDate(flow.created_at) || '—' }}
      </span>
    </ApprovalFlowSlotField>

    <ApprovalFlowSlotField
      label="Created by"
      :label-width="110"
    >
      <span class="text-body-2 text-textDarkest font-weight-medium">
        {{ formatUserDisplayName(flow.created_by) || '—' }}
      </span>
    </ApprovalFlowSlotField>

    <ApprovalFlowSlotField
      v-if="formattedCompletedAt"
      :label="completedOnLabel"
      :label-width="110"
    >
      <span class="text-body-2 text-textDarkest font-weight-medium">
        {{ formattedCompletedAt }}
      </span>
    </ApprovalFlowSlotField>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ApprovalFlowSlotField from '@/components/jobProfiles/editor/approvals/ApprovalFlowSlotField.vue';
import { formatUserDisplayName } from '@/helpers/user';
import { formatApprovalFlowDate } from '@/helpers/approvalFlows';

const props = defineProps({
  flow: {
    type: Object,
    required: true,
  },
  templateName: {
    type: String,
    default: '',
  },
});

const completedOnLabel = computed(() => {
  if (props.flow?.status === 'cancelled') return 'Cancelled on';
  if (props.flow?.status === 'rejected') return 'Rejected on';

  return 'Completed on';
});

const formattedCompletedAt = computed(() => {
  const { flow } = props;

  if (flow?.status === 'approved') return formatApprovalFlowDate(flow.approved_at);
  if (flow?.status === 'rejected') return formatApprovalFlowDate(flow.rejected_at);
  if (flow?.status === 'cancelled') return formatApprovalFlowDate(flow.cancelled_at);

  return '';
});
</script>
